import { Component, OnInit, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatRipple } from '@angular/material/core';
import { MatCard, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'app-thumbnail-icon-card',
    templateUrl: './thumbnail-icon-card.component.html',
    styleUrls: ['./thumbnail-icon-card.component.scss'],
    standalone: true,
    imports: [MatCard, MatRipple, NgClass, MatCardContent]
})
export class ThumbnailIconCardComponent implements OnInit {
  @Input() text: string;
  @Input() thumbnail: string;
  @Input() size?: string;

  constructor() { }

  ngOnInit() {
  }

}
